import { FieldError } from 'react-hook-form';
import { Menu } from '@chakra-ui/react';
import { CustomFormControl } from './CustomFormControl';
import { ReactElement, useState } from 'react';
import { CustomSelectBtn } from './CustomSelectEl/CustomSelectBtn';
import { CustomSelectList } from './CustomSelectEl/CustomSelectList';

export interface ICustomSelect {
  label?: string;
  value?: string;
  error?: FieldError | undefined;
  options?: any[];
  onChange?: Function;
  disabled?: boolean;
  sx?: object;
  renderBtnEl?: any;
}

export interface ISelectOption {
  key: string;
  label?: string | undefined;
  value: string | number;
  component?: ReactElement;
}

export const CustomSelect = (props: ICustomSelect) => {
  const { label, error, options, onChange, value, disabled, sx, renderBtnEl } = props;
  const [selectValue, setSelectValue] = useState<any | undefined>(value);

  const onHandleChange = (newValue: string | number) => {
    setSelectValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <CustomFormControl label={label} error={error} rightEl={{ hide: true }} sx={sx}>
      <Menu matchWidth>
        <CustomSelectBtn
          options={options}
          value={selectValue}
          error={!!error}
          disable={disabled}
          renderBtnEl={renderBtnEl}
        />
        <CustomSelectList options={options} onClickItem={onHandleChange} />
      </Menu>
    </CustomFormControl>
  );
};
